import { getService } from '../../parameters'
import SERVICES from '../../services.constants'
import request from '../utils/request'

export const requestBrowserCmsAlertBanner = () =>
  request
    .get(getService(SERVICES.ALERT_BANNER))
    .then(({ data }) => data)
    .catch(e => {
      console.warn('failed to fetch alert banner', e)
      return null
    })

export const requestBrowserCmsAddressPage = path => requestWebCms('/address-page', path)

const requestWebCms = (contentType, path) => {
  if (!path) return Promise.reject(new Error('Missing path!'))

  return request
    .get(getService(SERVICES.CMS, contentType), { params: { path: encodeURIComponent(path) } })
    .then(({ data }) => data)
    .catch(e => {
      console.warn('failed to fetch data from web cms ', e)
      return {}
    })
}
